import { useStore } from '@tanstack/react-form';
import { useMemo } from 'react';

import BlockInput from '../../../components/BlockInput/BlockInput';

import { useFieldContext, useFormContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

const BlockField = (props) => {
  const field = useFieldContext();
  const errors = useFieldErrors();

  const form = useFormContext();
  const blocksError = useStore(
    form.store,
    ({ errors }) => errors[0]?.[`${field.name}.blocks`],
  );

  const finalErrors = useMemo(
    () => [
      ...(errors || []),
      ...(blocksError
        ? [
            blocksError.map((error) =>
              typeof error === 'string' ? error : error.message,
            ),
          ]
        : []),
    ],
    [blocksError, errors],
  );

  return (
    <BlockInput
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={field.handleChange}
      onBlur={field.handleBlur}
      error={finalErrors}
    />
  );
};

export default BlockField;
